import { MediaLibrary } from '../../components/MediaLibrary/MediaLibrary';
import { UserGeneratedContentManager } from '../../components/UserGeneratedContentManager';
import { FormSection } from '../../components/ui/FormSection';

interface MediaLibraryTabProps {
  venueId: string;
}

export const MediaLibraryTab = ({ venueId }: MediaLibraryTabProps) => (
  <div>
    <FormSection title="Venue Media Library">
      <MediaLibrary
        entityType="venue"
        entityId={venueId}
        canUpload={true}
        canSetHero={true}
        canManageGallery={true}
        showSharedMedia={true}
      />
    </FormSection>

    <FormSection title="User-Generated Content">
      <UserGeneratedContentManager venueId={venueId} />
    </FormSection>
  </div>
);
